<template>
    <div class="position-relative has-tool-menu">
		<div class="tool-menu">
			<Breadcrumb />

			<div class="buttons">
				<ButtonAreas />
				
				<b-button v-if="module.access >= 30" variant="success" @click="newProductSpec"><span class="fa fa-plus"></span> Opret specifikation</b-button>
			</div>
		</div>

		<b-card no-body>
			<div slot="header">
				<i class="fa fa-tags"></i> Produkt specifikationer
				<div class="card-header-actions">
					<!-- <b-link href="#" class="card-header-action btn-setting">
						<i class="fa fa-cog"></i>
					</b-link> -->
				</div>
			</div>
			<DataTable ref="dataTable" v-if="fields" url="/api/module/products/productspecs" :fields="fields" name="productspecs" :filter="true">
				<template slot="5d139c4a0512d063ecf457fe" slot-scope="{props}">
					<b-link append :to="props.row.Id">
						{{props.row["5d139c4a0512d063ecf457fe"]}}
					</b-link>
				</template>
				<!-- <template slot="5d139c4a0512d063ecf457fe" slot-scope="{props}">
						{{$user(props.row["5d139c4a0512d063ecf457fe"]).name}}
				</template> -->
				<template slot="CreateDate" slot-scope="{props}">
					{{$moment(props.row.CreateDate).format("DD-MM-YYYY HH:mm")}}
				</template>
				<template slot="edit" slot-scope="{props}">
					<b-button append :to="props.row.Id" variant="primary"><i class="fa fa-eye"></i> Se mere</b-button>
				</template>
			</DataTable>
		</b-card>
	</div>
</template>

<script>
import newProductSpec from "./modals/_newProductSpec.vue";

export default {
	data: () => ({
		fields: null
	}),
	components: {},
	computed: {},
	methods: {
		newProductSpec() {
			this.$dialog.open(newProductSpec, { }, { title: "Opret specifikation", okTitle: "Opret" })
		}
	},
	created() {
		this.$http.get("/api/module/products/fields/productspec").then(x => {			
			this.fields = x.data;

			this.fields.push({
				name: "edit",
				visible: true,
				label: "",
				class: "text-right",
			});
		});
	},
	mounted() {}
};
</script>